import React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import theme from '../../../../assests/theme'
import { PasswordReset } from 'react-cognito';
import routes from '../../../navigation/Routes'
import PageContainer from '../../../ui/PageContainer'
import { MuiButton, MuiTextField, MuiEmailIcon, MuiLockIcon, MuiSnackbar, MuiCompareIcon, MuiInputAdornment, MuiTypography, muiWithStyles, MuiGrid } from '../../../ui/MaterialUIComponents';
import withAppShell from '../../../hoc/withAppShell/WithAppShell';
import MaterialUIForm from 'material-ui-form'
import { toast } from 'react-toastify';
import { SignUpActions } from '../../../../store'
import { connect } from 'react-redux'
import { getKeyFromLS } from '../../../../utils/LocalStorageUtil'
import lodashUtil from 'lodash'

export const User_Not_Found_Exception = "UserNotFoundException"
export const Code_Mismatch_Exception = "CodeMismatchException"
export const Expired_Code_Exception = "ExpiredCodeException"
export const Not_Authorized_Exception = "NotAuthorizedException"

class ResetPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      code: '',
      password: '',
      confirmPassword: '',
      message: '',
      error: '',
      isCodeSent: 0,
      snackBarOpenFlag: false,
      redirect: false
    };

  }

  componentWillMount() {
    let i18n;
    if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
      i18n = getKeyFromLS("i18n");
    } else {
      i18n = this.props.i18n
    }
    this.setState({
      i18n: i18n
    })
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      error: ''
    });
  };
  snackBarOpen = (toastMsg) => {
    this.setState({ snackBarOpenFlag: true, message: toastMsg });
  };

  snackBarClose = () => {
    this.setState({ snackBarOpenFlag: false });
  };



  validate = () => {
    const i18n = this.state.i18n
    var password = this.state.password

    if (this.state.code.length < 6) {
      this.setState({ error: i18n.resetPassword.invalidVerificationCode })
      return false;
    }
    if (password.length < 6) {
      this.setState({ error: i18n.resetPassword.errorMessageMinimumCharacter })
      return false;
    }
    if (password === this.state.confirmPassword) {
      return true;
    }
    else {
      this.setState({ error: i18n.resetPassword.passwordNotMatching })
      return false;
    }
  }
  onSubmit = () => {
    const i18n = this.state.i18n
    if (this.validate()) {
      this.props.setPassword(this.state.email, this.state.code, this.state.password)
        .then(() => {
          let message = SignUpActions.changePassword(this.state.email)
          this.setState({
            email: '',
            code: '',
            password: '',
            confirmPassword: '',
            error: '',
            isCodeSent: 0,
            redirect: true
          })
          this.snackBarOpen(i18n.resetPassword.resetSuccessfully)
        }
        )
        .catch((err) => {
          let errorMessage = this.manageErrorsFromCognitoForResetPassword(err.code, err.message);
          this.setState({
            error: errorMessage

          })
        }
        );
    }
  }



  sendVerificationCode = () => {
    const i18n = this.state.i18n
    this.props.sendVerificationCode(this.state.email)
      .then(() => {
        if (this.state.isCodeSent === 0) {
          this.setState({
            isCodeSent: 1,
            error: '',
            message: i18n.resetPassword.verifcationCodeDelay
          })
        } else {
          this.setState({
            isCodeSent: 1,
            error: '',
            message: i18n.resetPassword.verifcationCodeResent
          })
        }
      },

    )
      .catch((err) => {
        let errorMessage = this.manageErrorsFromCognitoForResetPassword(err.code, err.message)
        this.setState({
          error: errorMessage
        })
      });
  }

  manageErrorsFromCognitoForResetPassword = (errorCode, errorMessage) => {
    const i18n = this.state.i18n
    switch (errorCode) {
      case User_Not_Found_Exception:
        return i18n.cognitoErrorMessages.UserNotFoundException_RestPassword;
      case Code_Mismatch_Exception:
        return i18n.cognitoErrorMessages.CodeMismatchException_RestPassword;
      case Expired_Code_Exception:
        return i18n.cognitoErrorMessages.ExpiredCodeException_RestPassword;
      case Not_Authorized_Exception:
        return i18n.cognitoErrorMessages.NotAuthorizedException_RestPassword;
      default:
        return errorMessage
    }
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to={routes.main} />
    }
  }

  render() {
    const { i18n } = this.state
    return (
      <div className="App" style={{marginTop:"64px"}}>
        {this.renderRedirect()}
        <MuiSnackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={this.state.snackBarOpenFlag}
          onClose={this.snackBarClose}

          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{this.state.message}</span>}

        />
        <MaterialUIForm onSubmit={this.sendVerificationCode}>
          <MuiTypography variant={theme.typographyStyles.H4} color="primary">
            {i18n.resetPassword.forgotPassword}
          </MuiTypography>

          <MuiTextField
            id="email"
            label="Email"
            type="email"
            data-validators="isRequired,isEmail" margin="normal" placeholder="example@gmail.con"
            onChange={this.handleChange('email')}
            style={theme.muiTextFieldStyleForMainScreen}

            required
            InputProps={{
              startAdornment: (
                <MuiInputAdornment position="start">
                  <MuiEmailIcon color='primary' />
                </MuiInputAdornment>
              ),
            }}
          />

          <br />

          <div>
            <MuiGrid container xs={12} justify="flex-end" spacing={1}>
              <MuiGrid item >{
                !this.state.isCodeSent ?
                  <Link to={routes.main} style={theme.linkStyle}>
                    <MuiButton style={theme.secondaryButtonStyle}>{i18n.resetPassword.login}</MuiButton>
                  </Link>
                  :
                  null
              }</MuiGrid>
              <MuiGrid item >
                <MuiButton type="submit" style={theme.primaryButtonStyle}>
                  {
                    this.state.isCodeSent ?
                      'Resend otp'
                      :
                      'send Otp'
                  }</MuiButton></MuiGrid>

            </MuiGrid>

          </div>

        </MaterialUIForm>

        {
          this.state.isCodeSent ?
            <div>

              <MaterialUIForm onSubmit={this.onSubmit}>
                <MuiTypography variant={theme.typographyStyles.SUBTITLE1} style={{ color: theme.palette.primary.main }}>{this.state.message}</MuiTypography>
                <MuiTextField
                  className={this.props.classes.number}
                  id="verficationcode"
                  label="Verfication Code"
                  onChange={this.handleChange('code')}
                  margin="normal"
                  placeholder="Enter 6 digit verfication code" style={theme.muiTextFieldStyleForMainScreen}
                  type="number"
                  data-validators="isRequired"
                  required
                  InputProps={{
                    startAdornment: (
                      <MuiInputAdornment position="start">
                        <MuiCompareIcon color='primary' />
                      </MuiInputAdornment>
                    ),
                  }}
                />



                <br />

                <MuiTextField id="password" label="Password" onChange={this.handleChange('password')} margin="normal"
                  data-validators="isRequired,isAlpha" placeholder="Enter your Password" style={theme.muiTextFieldStyleForMainScreen} type="password" required

                  InputProps={{
                    startAdornment: (
                      <MuiInputAdornment position="start">
                        <MuiLockIcon color='primary' />
                      </MuiInputAdornment>
                    ),
                  }}
                />

                <br />
                <MuiTextField id="confirmPassword" label="Confirm Password" onChange={this.handleChange('confirmPassword')} margin="normal"
                  data-validators="isRequired,isAlpha" placeholder="Re-enter your password" style={theme.muiTextFieldStyleForMainScreen} type="password" required

                  InputProps={{
                    startAdornment: (
                      <MuiInputAdornment position="start">
                        <MuiLockIcon color='primary' />
                      </MuiInputAdornment>
                    ),
                  }}
                />
                <br />
                <div style={{ paddingBottom: '3%' }}>
                  <MuiTypography
                    corvariant={theme.typographyStyles.CAPTION}
                    color="error" >
                    {this.state.error}
                  </MuiTypography>

                </div>
                <MuiTypography variant="caption" color="primary">{i18n.resetPassword.minmumPasswordLength}</MuiTypography>
                <br />
                <MuiGrid container
                  xs={12}
                  direction="row"
                  justify="flex-end"
                  alignItems="center"
                  spacing={1}
                >
                  <MuiGrid item>
                    <Link to={routes.main} style={theme.linkStyle}>
                      <MuiButton style={theme.secondaryButtonStyle} >{i18n.resetPassword.login}</MuiButton>
                    </Link>
                  </MuiGrid>
                  <MuiGrid item>
                    <MuiButton style={theme.primaryButtonStyle} type="submit" >
                      {i18n.resetPassword.submit}</MuiButton></MuiGrid>
                </MuiGrid>
                <br />
              </MaterialUIForm>
            </div>
            :
            null
        }
      </div>

    )
  }
}


ResetPasswordForm.propTypes = {
  error: PropTypes.string,
  username: PropTypes.string,
  sendVerificationCode: PropTypes.func,
  isCodeSent: PropTypes.bool,
  setPassword: PropTypes.func,

};


const ResetPassword = (props) => (
  <PageContainer>
    <PasswordReset>
      <ResetPasswordForm {...props} />
    </PasswordReset>
  </PageContainer>
)


const componentStyle = theme => ({
  number: {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    }
  }
});

const mapStateToProps = (state, ownProps) => {
  return {
    i18n: state.i18nMessages.i18n
  }
}

export default withAppShell((muiWithStyles(componentStyle), connect(mapStateToProps)(ResetPassword)), { properties: { isProtected: false } });
